import httpService from "../httpService";

export const vbOutgoingDocReceiversTdhvpService = {
  findAllByDocIdAndObjectType(docId, objectType) {
    let params = { docId, objectType };
    return httpService.get(
      "/vbOutgoingDocReceiversTdhvp/findAllByDocIdAndObjectType",
      { params: params }
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/tdhvp/vbOutgoingDocReceiversTdhvpService.js